import WalletView from "@/views/wallet/WalletView";
//withdraw
import BankWithdrawForm from "@/views/wallet/Widthdraw/BankWithdrawForm";
import BankWithdrawFormOtp from "@/views/wallet/Widthdraw/BankWithdrawFormOtp";
import CashWithdrawForm from "@/views/wallet/Widthdraw/CashWithdrawForm";
import CashWithdrawFormOtp from "@/views/wallet/Widthdraw/CashWithdrawFormOtp";
import CryptoWithdrawForm from "@/views/wallet/Widthdraw/CryptoWithdrawForm";
import CryptoWithdrawFormOtp from "@/views/wallet/Widthdraw/CryptoWithdrawFormOtp";
import WithdrawView from "@/views/wallet/Widthdraw/WithdrawView";

//deposit
import BankDepositForm from "@/views/wallet/Deposit/BankDepositForm";
import CashDepositForm from "@/views/wallet/Deposit/CashDepositForm";
import CryptoDepositForm from "@/views/wallet/Deposit/CryptoDepositForm";
import GpayDepositForm from "@/views/wallet/Deposit/GpayDepositForm";
import DebitCreditCards from "@/views/wallet/Deposit/DebitCreditCards";
import DepositView from "@/views/wallet/Deposit/DepositView";

//internal
import InternalTransferForm from "@/views/wallet/Internal/InternalTransferForm";

export default {
  WalletView,
  DepositView,
  BankDepositForm,
  CashDepositForm,
  CryptoDepositForm,
  GpayDepositForm,
  DebitCreditCards,
  WithdrawView,
  CashWithdrawForm,
  CashWithdrawFormOtp,
  BankWithdrawForm,
  BankWithdrawFormOtp,
  CryptoWithdrawForm,
  CryptoWithdrawFormOtp,
  InternalTransferForm,
};
